export default __webpack_public_path__ + "static/media/Juneau-Bold.6c758044.otf";